var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('rabbey-table-3',{attrs:{"show-summary":"","summary-method":_vm.getSummaries,"search":_vm.PaymenFilter,"data":_vm.reportData,"columns":_vm.reportColumns,"actions":_vm.reportActions,"loading":_vm.reportDataLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }